module.exports = "/_next/static/images/90f054c235c1c42b5f29fd11027c9bba-pay-yourself-md@2x.jpg.webp";